import { render, staticRenderFns } from "./question.vue?vue&type=template&id=3a9254e4&scoped=true&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"
import style0 from "./question.vue?vue&type=style&index=0&id=3a9254e4&prod&lang=scss&scoped=true&"
import style1 from "./question.vue?vue&type=style&index=1&id=3a9254e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9254e4",
  null
  
)

export default component.exports